import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private errorHandlingService: ErrorHandlingService) {}

  public handleError(error: any): void {
    let errorMessage = error;

    if (typeof error === 'object' && error.hasOwnProperty('rejection')) {
      errorMessage = error.rejection.message;
    }
    this.errorHandlingService.showGlobalError(errorMessage, error);
  }
}
